import Tweet from "../../../../src/components/tweet";
import * as React from 'react';
export default {
  Tweet,
  React
};